import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/config/site";
import { trackEvent, EVENTS } from "@/utils/track";

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-recover text-white shadow-[0_12px_28px_-8px_rgba(54,162,105,0.55)] transition-all duration-200 hover:scale-105 hover:shadow-[0_16px_32px_-8px_rgba(54,162,105,0.65)]"
      onClick={() => trackEvent(EVENTS.WHATSAPP_CLICK, { ubicacion: "boton_flotante" })}
    >
      <MessageCircle className="h-7 w-7" strokeWidth={1.8} />
    </a>
  );
}
